export const cilLoop1 = ["24 24","<path d='M9.75 14.625v1.5h5.25v-1.5h-1.875v-6.375h-1.5v1.125h-1.5v1.5h1.5v3.75h-1.875z'></path><path d='M21.75 9.868v2.507c-0.003 2.898-2.352 5.247-5.25 5.25h-12.815l2.094-2.095-1.060-1.060-3.876 3.875 3.469 3.904 1.125-0.997-1.892-2.127h12.955c3.722 0 6.75-3.028 6.75-6.75v-4.007z'></path><path d='M2.25 12c0.003-2.898 2.352-5.247 5.25-5.25h12.815l-2.094 2.095 1.060 1.060 3.876-3.875-3.469-3.904-1.125 0.997 1.892 2.127h-12.955c-3.722 0-6.75 3.028-6.75 6.75v4.021l1.5-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-loop-1.js
// module id = null
// module chunks = 